<template>
  <v-toolbar :clipped-left="true" app fixed color="primary">
    <v-toolbar-title>
      <v-toolbar-side-icon
        class="nav-btn"
        @click.stop="miniNav = !miniNav"
      ></v-toolbar-side-icon>
    </v-toolbar-title>

    <span style="width: 400px" v-if="plantSelectionRequired && !widthBoolean">
      <v-autocomplete
        class="mx-3 autocomplete"
        :background-color="$vuetify.theme.bg"
        :items="plant_list"
        v-model="plant"
        placeholder="Search Plant"
        solo-inverted
        flat
        dense
        hide-no-data
        hide-details
        hide-selected
        :allow-overflow="false"
        :single-line="true"
      >
      </v-autocomplete>
    </span>
    <v-spacer></v-spacer>
    <!-- TODO: Keep logo as null if user doesn't have logo -->
    <div
      v-if="
        getUserInfo('logo') !=
        'https://scada4x-assets.s3.ap-south-1.amazonaws.com/blank.svg'
      "
    >
      <span class="logo-img-plant">
        <img :src="getUserInfo('logo')" />
      </span>
    </div>

    <img
      v-if="computeLogoAddress && isImageDisable"
      :src="computeLogoAddress"
      class="customer-logo"
      width="100"
      height="30"
    />
    <v-tooltip color="bg" bottom>
      <NotificationMenu
        slot="activator"
        :notifications="getGeneralState('notifications')"
      />
      <span class="tooltip-text__color">{{ $t("Notification") }}</span>
    </v-tooltip>
    <v-tooltip color="bg" bottom>
      <v-btn
        flat
        icon
        slot="activator"
        v-on:click="changeTheme"
        class="hidden-sm-and-down"
      >
        <v-icon>invert_colors</v-icon>
      </v-btn>
      <span class="tooltip-text__color">{{ $t("Theme") }} </span>
    </v-tooltip>
    <v-tooltip color="bg" bottom :disabled="widthBoolean">
      <v-btn
        flat
        icon
        slot="activator"
        @click="toggleReload"
        @dblclick="instantRefresh"
      >
        <v-icon :color="refreshButtonColor">refresh</v-icon>
      </v-btn>
      <span class="tooltip-text__color"
        >{{ $t("Auto-Refresh - Every") }} {{ getReloadTimeInMin }} Minute</span
      ><br />
      <span class="tooltip-text__color"
        >{{ $t("Last Updated") }}: {{ getGeneralState("lastCallTime") }}</span
      ><br />
      <span class="note">{{ $t("Single Click - Toggle Auto Reload") }}</span
      ><br />
      <span class="note">{{ $t("Double Click - Instant Refresh") }}</span
      ><br />
    </v-tooltip>
    <v-tooltip color="bg" bottom>
      <v-btn
        flat
        icon
        slot="activator"
        @click="toggleFullscreen"
        class="hidden-sm-and-down"
      >
        <v-icon v-if="isFullscreen">fullscreen_exit</v-icon>
        <v-icon v-else>fullscreen</v-icon>
      </v-btn>
      <span class="tooltip-text__color">{{ $t("Fullscreen") }}</span>
    </v-tooltip>
    <v-tooltip color="bg" bottom>
      <LanguageSelectBox slot="activator" />
      <span class="tooltip-text__color">{{ $t("Select Language") }}</span>
    </v-tooltip>
    <div class="brand-logo">
      <div class="logo-img">
        <img src="./../../assets/logo/enerman.svg" />
      </div>
    </div>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { EventBus } from "@/services/event-bus";
const NotificationMenu = () => import("@/components/NotificationMenu");
const LanguageSelectBox = () => import("@/components/common/LanguageSelectBox");

export default {
  components: {
    NotificationMenu,
    LanguageSelectBox,
  },
  data() {
    return {
      isImageDisable: false,
      goDark: true,
      isFullscreen: false,
      plant1: "",
      isOpen: false,
    };
  },
  mounted() {
    if (this.getGeneralState("notifications").length < 10) {
      this.fetchNotification({
        idList: this.getPlantList.map((el) => el.id),
        skip: this.getGeneralState("notifications").length,
        limit: 10 - this.getGeneralState("notifications").length,
      });
    }
    this.goDark = this.getGeneralState("theme_dark");
    this.updateThemeStyle()
  },
  computed: {
    ...mapGetters([
      "getSelectedPlantId",
      "getPlantId",
      "getUserInfo",
      "getActivePlantInfo",
      "getGeneralState",
      "getReloadTimeInMin",
      "getPlantList",
    ]),
    plant: {
      get() {
        return this.getActivePlantInfo("plant_name");
      },
      set(value) {
        let plantId = this.getPlantId(value)[0];
        if (!plantId) {
          return;
        }

        this.SET_SELECTED_PLANT_ID(plantId);
        if (!this.getGeneralState("mapRedirectPlant")) {
          EventBus.$emit("plantChanged", plantId);
        } else {
          this.SET_MAP_REDIRECT_PLANT(false);
        }
      },
    },
    plantSelectionRequired() {
      return (
        this.$route.name !== "home" &&
        this.$route.name !== "thinkHome" &&
        this.$route.name !== "plantAnalytics"
      );
    },
    widthBoolean() {
      return this.currentWidth < 960;
    },
    plant_list() {
      return this.getPlantList.map((el) => el.name);
    },
    computeLogoAddress() {
      let image = this.getActivePlantInfo("logo");

      if (image == null) {
        return "";
      }
      return image;
    },
    refreshButtonColor() {
      let color = this.getGeneralState("autoReload") ? "" : "red";
      return color;
    },
    miniNav: {
      get() {
        return this.getGeneralState("miniNav");
      },
      set(value) {
        this.SET_MINI_NAV(value);
      },
    },
  },
  methods: {
    ...mapActions(["fetchNotification"]),
    ...mapMutations([
      "SET_THEME",
      "SET_SELECTED_PLANT_ID",
      "SET_MAP_REDIRECT_PLANT",
      "SET_AUTO_RELOAD",
      "SET_INSTANT_REFRESH",
      "SET_MINI_NAV",
    ]),
    ...mapActions(["fetchNotification"]),
    changeTheme: function () {
      this.goDark = !this.goDark;
      this.SET_THEME(this.goDark);

      this.updateThemeStyle()
    },
    updateThemeStyle() {
      if (this.goDark) {
        this.$vuetify.theme.bg = "#04112F";
        this.$vuetify.theme.primary = "#000427";
        this.$vuetify.theme.secondary = "#3D485D";
        this.$vuetify.theme.primaryText = "#ffffff";
        this.$vuetify.theme.sixth = "#121a37";
        this.$vuetify.theme.extraGrey = "#D4D4D4";
        this.$vuetify.theme.number = "#668cf6";
      } else {
        this.$vuetify.theme.primary = "#fdfaf6";
        this.$vuetify.theme.bg = "#e4efe7";
        this.$vuetify.theme.secondary = "#faf1e6";
        this.$vuetify.theme.primaryText = "#000000";
        this.$vuetify.theme.sixth = "#D9D9D9";
        this.$vuetify.theme.extraGrey = "#696969";
        this.$vuetify.theme.number = "#2C62F7";
      }
    },
    toggleReload() {
      this.SET_AUTO_RELOAD(!this.getGeneralState("autoReload"));
    },
    instantRefresh() {
      console.log("DOUBLE CLICKED");
      this.SET_INSTANT_REFRESH(!this.getGeneralState("instantRefresh"));
    },
    toggleFullscreen(event) {
      var elem = document.documentElement;
      if (
        document.fullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.msFullscreenEnabled
      ) {
        if (!this.isFullscreen) {
          if (elem.requestFullscreen) {
            elem.requestFullscreen();
            this.isFullscreen = true;
          } else if (elem.webkitRequestFullscreen) {
            elem.webkitRequestFullscreen();
            this.isFullscreen = true;
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
            this.isFullscreen = true;
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
            this.isFullscreen = true;
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
            this.isFullscreen = false;
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
            this.isFullscreen = false;
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
            this.isFullscreen = false;
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
            this.isFullscreen = false;
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.theme--light .tooltip-text__color {
  color: #000;
}
@media (max-width: 960px) {
  .nav-btn,
  .ag-info-name {
    color: #04112f !important;
  }

  .logo-img img {
    margin-top: 5px;
  }

  .logo-img-plant {
    display: none;
  }
}
</style>

<style scoped>
.logo-img img {
  height: 44px;
  width: 100px;
  margin-top: 8px;
  margin-right: -10px;
  margin-left: 10px;
}

.logo-img-plant img {
  height: 44px;
  width: 100px;
  margin-top: 8px;
  margin-right: 10px;
}

.customer-logo {
  width: 100px;
  height: 30px;
  margin: 0px 10px;
}

.note {
  color: #fbbc05;
}

.nav-btn {
  margin-left: -2px;
  margin-right: 10px;
}

.brand-logo {
  margin-left: 2px;
}
</style>

<style>
.autocomplete.v-select__selection,
.autocomplete.v-select__selection--comma,
.autocomplete.v-select.v-text-field input {
  color: var(--v-primaryText-base) !important;
}

.theme--dark .v-select-list > .v-list {
  background-color: #30395b;
  color: white;
}
</style>
